/* eslint-disable @typescript-eslint/naming-convention */
/* eslint-disable no-param-reassign */
import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { ApplicationsState, ServiceToken, ApplicationStatistics } from "./types";

const initialState: ApplicationsState = {
  tokens: {
    data: null,
    loading: false,
    error: null,
  },
  stats: {},
};

const applicationsSlice = createSlice({
  name: "applications",
  initialState,
  reducers: {
    // Get Tokens Actions
    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    getApplicationTokens: (state, _: PayloadAction<{ accessToken: string }>) => {
      state.tokens.loading = true;
      state.tokens.error = null;
    },
    getApplicationTokensSuccess: (state, action: PayloadAction<ServiceToken[]>) => {
      state.tokens.data = action.payload;
      state.tokens.loading = false;
      state.tokens.error = null;
    },
    getApplicationTokensFailure: (state, action: PayloadAction<string>) => {
      state.tokens.loading = false;
      state.tokens.error = action.payload;
    },

    // Get Stats Actions
    getApplicationStats: (
      state,
      action: PayloadAction<{
        accessToken: string;
        serviceTokenId: string;
        startAt: string;
        endAt: string;
      }>,
    ) => {
      const { serviceTokenId } = action.payload;
      if (!state.stats[serviceTokenId]) {
        state.stats[serviceTokenId] = {
          data: null,
          loading: false,
          error: null,
        };
      }
      state.stats[serviceTokenId].loading = true;
      state.stats[serviceTokenId].error = null;
    },
    getApplicationStatsSuccess: (
      state,
      action: PayloadAction<{ serviceTokenId: string; data: ApplicationStatistics }>,
    ) => {
      const { serviceTokenId, data } = action.payload;
      state.stats[serviceTokenId] = {
        data,
        loading: false,
        error: null,
      };
    },
    getApplicationStatsFailure: (
      state,
      action: PayloadAction<{ serviceTokenId: string; error: string }>,
    ) => {
      const { serviceTokenId, error } = action.payload;
      if (state.stats[serviceTokenId]) {
        state.stats[serviceTokenId].loading = false;
        state.stats[serviceTokenId].error = error;
      }
    },
  },
});

export const {
  getApplicationTokens,
  getApplicationTokensSuccess,
  getApplicationTokensFailure,
  getApplicationStats,
  getApplicationStatsSuccess,
  getApplicationStatsFailure,
} = applicationsSlice.actions;

export default applicationsSlice.reducer;
